import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const APP_NAME = import.meta.env.VITE_APP_NAME ?? "Job Goblin";

export function HomePage() {
  return (
    <div className="container py-12">
      <div className="mx-auto max-w-3xl space-y-8">
        <div className="space-y-3">
          <Badge variant="accent">v1 — scaffolding</Badge>
          <h1 className="text-4xl font-bold tracking-tight">
            <span aria-hidden className="mr-2">
              🧌
            </span>
            {APP_NAME}
          </h1>
          <p className="text-lg text-muted-foreground">
            Multi-runner AI orchestrator. Trigger.dev tasks routed to your own
            hardware, with a hosted playground for humans and a scoped API for
            services.
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          <Button asChild>
            <Link to="/playground">Open Playground</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/history">View History</Link>
          </Button>
        </div>

        <div className="rounded-lg border bg-card p-6 text-card-foreground">
          <h2 className="mb-2 text-lg font-semibold">What works in this build</h2>
          <ul className="list-inside list-disc space-y-1 text-sm text-muted-foreground">
            <li>Top-nav project switcher (placeholder data)</li>
            <li>Cmd+K command menu — try it</li>
            <li>Light / dark / system theme toggle</li>
            <li>Routing skeleton for playground, history, and admin pages</li>
          </ul>
          <p className="mt-3 text-sm text-muted-foreground">
            Phase 2 (auth + Supabase) and Phase 3 (admin pages) light up the
            rest. See <code className="rounded bg-muted px-1 py-0.5">CONTRIBUTING.md</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
